import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { ITransactionDescriptionProps, ITransactionsListProps } from 'features/Kredits/views/Transactions/List/types'
import { KreditTransactionUtils } from 'features/Kredits/utils'
const {
  isDeposit,
  isWithdrawal,
  isBookingSource,
  isSaleSource,
  isMobileLineSource,
  isKolorsKreditsTransaction,
  isCorporateKreditsTransaction,
  isBonusTransaction,
  isRefund
} = KreditTransactionUtils

const TransactionDescription = ({ transaction }: ITransactionDescriptionProps): ReactElement => {
  if (isRefund(transaction)) {
    if (isKolorsKreditsTransaction(transaction)) {
      return (
        <FormattedMessage
          id="wallet.transactions.list.description.refund.kolors"
          defaultMessage="Kolors Credits Refund"
        />
      )
    }
    if (isCorporateKreditsTransaction(transaction)) {
      return (
        <FormattedMessage
          id="wallet.transactions.list.description.refund.corporate"
          defaultMessage="Corporate Credits Refund"
        />
      )
    }
    if (isBonusTransaction(transaction)) {
      return (
        <FormattedMessage
          id="wallet.transactions.list.description.deposit.admin"
          defaultMessage="Bonus Credits Refund"
        />
      )
    }
  }

  if (isDeposit(transaction)) {
    if (isBonusTransaction(transaction)) {
      return <FormattedMessage id="wallet.transactions.list.description.deposit.admin" defaultMessage="Bonus Credits" />
    }
    if (isKolorsKreditsTransaction(transaction)) {
      if (isBookingSource(transaction.source)) {
        return <FormattedMessage id="kredits.transactions.list.description.deposit.booking" defaultMessage="Refund" />
      }
      if (isSaleSource(transaction.source)) {
        return (
          <FormattedMessage
            id="kredits.transactions.list.description.deposit.payment"
            defaultMessage="Top Up Credits"
          />
        )
      }
    }
    if (isCorporateKreditsTransaction(transaction)) {
      return (
        <FormattedMessage
          id="wallet.transactions.list.description.deposit.corporate"
          defaultMessage="Corporate Credits Top Up"
        />
      )
    }
  }

  if (isWithdrawal(transaction)) {
    if (isCorporateKreditsTransaction(transaction)) {
      return (
        <FormattedMessage
          id="wallet.transactions.list.description.withdrawal.corporate"
          defaultMessage="Corporate Credits Purchase"
        />
      )
    }
    if (isBookingSource(transaction.source)) {
      return <FormattedMessage id="kredits.transactions.list.description.booking" defaultMessage="Trip" />
    }
    if (isMobileLineSource(transaction.source)) {
      return <FormattedMessage id="wallet.transactions.list.description.mobile" defaultMessage="Recarga de saldo" />
    }
  }
  return <span>-</span>
}

export const TransactionsList = ({ transactions = [] }: ITransactionsListProps): ReactElement => {
  const intl = useIntl()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            <Th>
              <FormattedMessage id="kredits.transactions.list.header.date" defaultMessage="Date" />
            </Th>
            <Th>
              <FormattedMessage id="kredits.transactions.list.header.concept" defaultMessage="Concept" />
            </Th>
            <Th>
              <FormattedMessage id="kredits.transactions.list.header.amount" defaultMessage="Amount" />
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {transactions.map((transaction): ReactElement => {
            return (
              <Tr key={transaction.id}>
                <Td>
                  <FormattedDate
                    intl={intl}
                    value={transaction.createdAt}
                    month="2-digit"
                    day="2-digit"
                    year="numeric"
                  />
                </Td>
                <Td>
                  <TransactionDescription transaction={transaction} />
                </Td>
                <Td>
                  <strong>
                    <FormattedPrice value={transaction.amount} />
                  </strong>
                </Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
